import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[tableHost]'
})
export class TableHostDirective {

  constructor(
    public viewContainerRef: ViewContainerRef
  ) {
  }

}
